import { render, staticRenderFns } from "./selection-table-group-header.vue?vue&type=template&id=67c3190e&scoped=true"
import script from "./selection-table-group-header.vue?vue&type=script&lang=ts"
export * from "./selection-table-group-header.vue?vue&type=script&lang=ts"
import style0 from "./selection-table-group-header.vue?vue&type=style&index=0&id=67c3190e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c3190e",
  null
  
)

export default component.exports